export interface PHASE_ONE_INPUT {
  FirstName: string;
  LastName: string;
  Email: string;
  MobileNumber: string;
  CountryId: string;
  Password: string;
  AgreeToPrivacyPolicy: boolean;
  SavePhasesDataType: number;
}

export interface PHASE_RESPONSE {
  IsRegisteredBefore?: boolean;
  IsMobileNumberVerified?: boolean;
  IsMobileNumberEdited?: boolean;
  RegistrationCycleLogId?: string;
}

export interface COUNTRY {
  Id: number;
  ISO3166Code: string;
  CallingCode: string;
  GlobalName: string;
  MaxMobileLength: number;
  SearchName: string;
  FlagPath: string;
  IsCurrentCountry?: boolean;
}

export interface BUSINESS_TYPE_INPUT {
  RegistrationCycleLogId?: string;
  BusinessName?: string;
  BusinessTypes?: number[];
  CountryId?: string;
  CityId?: string;
  KnowUsWayId?: string;
  IsCurrentlyUsingAnyOtherSystem?: boolean;
}

export interface BUSINESS_TYPE_RESPONSE {}

export interface VERFICATION_CODE_INPUT {
  RegistrationCycleLogId: string;
  VerifyMobileNumberType: number;
}

export interface VERIFICATION_CODE_RESPONSE {}
